// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainLayout_mainLayout__pL48- {
  min-height: 100vh;
  background: var(--bg-base);
}

.MainLayout_siteLayout__Co6RK {
  background: transparent;
}

.MainLayout_mainContent__8l4-S {
  margin: 0;
  padding: 0;
  min-height: calc(100vh - 64px);
  background: transparent;
}

.MainLayout_contentWrapper__Ss884 {
  position: relative;
  animation: MainLayout_fadeIn__Q0vwg 0.5s ease-out;
}

.MainLayout_contentWrapper__Ss884 > * {
  animation: MainLayout_slideInUp__BuIKI 0.4s ease-out;
}

.MainLayout_mainContent__8l4-S::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.MainLayout_mainContent__8l4-S::-webkit-scrollbar-track {
  background: var(--bg-surface);
  border-radius: var(--radius-sm);
}

.MainLayout_mainContent__8l4-S::-webkit-scrollbar-thumb {
  background: var(--accent-grad);
  border-radius: var(--radius-sm);
}

.MainLayout_mainContent__8l4-S::-webkit-scrollbar-thumb:hover {
  background: var(--accent-hover);
}

@keyframes MainLayout_fadeIn__Q0vwg {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes MainLayout_slideInUp__BuIKI {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 992px) { .MainLayout_mainContent__8l4-S { padding: 16px; } }
@media (max-width: 768px) { .MainLayout_mainContent__8l4-S { padding: 12px; } }
@media (max-width: 576px) { .MainLayout_mainContent__8l4-S { padding: 8px;  } }`, "",{"version":3,"sources":["webpack://./src/components/common/Layout/MainLayout.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iDAA+B;AACjC;;AAEA;EACE,oDAAkC;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,4BAA4B,iCAAe,aAAa,EAAE,EAAE;AAC5D,4BAA4B,iCAAe,aAAa,EAAE,EAAE;AAC5D,4BAA4B,iCAAe,YAAY,GAAG,EAAE","sourcesContent":[".mainLayout {\n  min-height: 100vh;\n  background: var(--bg-base);\n}\n\n.siteLayout {\n  background: transparent;\n}\n\n.mainContent {\n  margin: 0;\n  padding: 0;\n  min-height: calc(100vh - 64px);\n  background: transparent;\n}\n\n.contentWrapper {\n  position: relative;\n  animation: fadeIn 0.5s ease-out;\n}\n\n.contentWrapper > * {\n  animation: slideInUp 0.4s ease-out;\n}\n\n.mainContent::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.mainContent::-webkit-scrollbar-track {\n  background: var(--bg-surface);\n  border-radius: var(--radius-sm);\n}\n\n.mainContent::-webkit-scrollbar-thumb {\n  background: var(--accent-grad);\n  border-radius: var(--radius-sm);\n}\n\n.mainContent::-webkit-scrollbar-thumb:hover {\n  background: var(--accent-hover);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes slideInUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@media (max-width: 992px) { .mainContent { padding: 16px; } }\n@media (max-width: 768px) { .mainContent { padding: 12px; } }\n@media (max-width: 576px) { .mainContent { padding: 8px;  } }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainLayout": `MainLayout_mainLayout__pL48-`,
	"siteLayout": `MainLayout_siteLayout__Co6RK`,
	"mainContent": `MainLayout_mainContent__8l4-S`,
	"contentWrapper": `MainLayout_contentWrapper__Ss884`,
	"fadeIn": `MainLayout_fadeIn__Q0vwg`,
	"slideInUp": `MainLayout_slideInUp__BuIKI`
};
export default ___CSS_LOADER_EXPORT___;
